import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import clsx from 'clsx';
import Header from '../misc/Header';
import Section from '../../Section';
import settings from './settings';
import { getLayoutGridAttr, getLayoutSectionCountAttr } from '../../../misc/StyleVariables';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const NoneLayoutVariant = _ref => {
  let {
    config,
    editing = false,
    disabled = false,
    activeSectionId,
    orderedSections,
    widgetId,
    reportingWidgetId,
    widgetElementId,
    workbookUrl,
    workbook,
    workbookMeta,
    isMediumContainer,
    isLargeContainer,
    globalVariables,
    stylesMainSections // children,

  } = _ref;
  const {
    heading = ''
  } = config;
  const isMediumUp = isMediumContainer || isLargeContainer;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, isMediumUp ? styles['container--mediumUp'] : '', isMediumContainer ? styles['container--medium'] : '', isLargeContainer ? styles['container--large'] : ''),
    children: [/*#__PURE__*/_jsx(Header, {
      widgetId: widgetId,
      heading: heading,
      sections: orderedSections,
      isMediumContainer: isMediumContainer,
      isLargeContainer: isLargeContainer
    }), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
      className: clsx(styles.main, isMediumUp ? styles['main--mediumUp'] : '', isMediumContainer ? styles['main--medium'] : '', isLargeContainer ? styles['main--large'] : '')
    }, getLayoutSectionCountAttr(orderedSections.length)), getLayoutGridAttr(_objectSpread(_objectSpread({}, globalVariables), stylesMainSections))), {}, {
      children: orderedSections.map((section, index) => /*#__PURE__*/_jsx(Section, {
        editing: editing,
        disabled: disabled,
        selected: activeSectionId === section.id,
        className: styles.cell,
        id: section.id || '',
        data: section,
        widgetId: widgetId,
        reportingWidgetId: reportingWidgetId,
        widgetElementId: widgetElementId || '',
        index: index,
        workbookUrl: workbookUrl,
        workbook: workbook,
        workbookMeta: workbookMeta,
        isMediumContainer: isMediumContainer,
        isLargeContainer: isLargeContainer
      }, `${widgetId}-${index}`))
    }))]
  });
};

export default NoneLayoutVariant;
export { settings, styles };